import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  PageHeader,
  Button,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Select,
  Switch, Checkbox, DatePicker,
} from "antd";

import * as settingAPI from "../../../api/setting";

import {
  CloseOutlined,
  CheckOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment/moment";
import {deleteBanner} from "../../../api/setting";

function BannerForm({ isEdit }) {
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState(null);

  const [image, setImage] = useState([]);

  const fetchBanner = () => {
    settingAPI
      .getBanner({ id: params.id })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setBanner(res.data.data);
          setImage(res.data.data.images);
          setLoading(false);
        } else {
          alert(res.data.data.msg);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  useEffect(() => {
    if (isEdit) {
      fetchBanner();
    } else {
      setLoading(false);
    }
  }, []);

  const onFinish = (values) => {
    if (isEdit) {
      settingAPI
        .editBanner({
          ...banner,
          ...values,
        })
        .then((res) => {
          if (res.data.linusCode === 1) {
            message.success("성공적으로 수정되었습니다.");
            navigate(`/setting/banner`);
          } else {
            message.error(res.data.data.msg);
          }
        })
        .catch((error) => {
          if (error.response.data.detail) {
            message.error(error.response.data.detail);
          } else if (error.response.status < 500) {
            for (let key of Object.keys(error.response.data)) {
              message.error(`${key}: ${error.response.data[key]}`);
            }
          } else {
            message.error("오류가 발생했습니다.");
          }
        });
    } else {
      settingAPI
        .createBanner({
          ...values,
        })
        .then((res) => {
          if (res.data.linusCode === 1) {
            message.success("성공적으로 등록되었습니다.");
            navigate(`/setting/banner`);
          } else {
            message.error(res.data.data.msg);
          }
        })
        .catch((error) => {
          if (error.response.data.detail) {
            message.error(error.response.data.detail);
          } else if (error.response.status < 500) {
            for (let key of Object.keys(error.response.data)) {
              message.error(`${key}: ${error.response.data[key]}`);
            }
          } else {
            message.error("오류가 발생했습니다.");
          }
        });
    }
  };

  const onUpload = (newImage) => {
    settingAPI.saveBannerImage(newImage).then((res) => {
      if (res.data.linusCode === 1) {
        setImage([res.data.data]);
      }
    });

    return false;
  };

  const onDelete = (e) => {
    e.preventDefault();
    settingAPI
      .deleteBanner({ id: banner?.id })
      .then((res) => {
        if (res.data.linusCode === 1) {
          message.success("성공적으로 삭제되었습니다.");
          navigate(`/setting/banner`);
        } else {
          alert(res.data.data.msg);
        }
      });
  };

  return (
    <>
      <div>
        <PageHeader
          className="site-page-header"
          title={`배너 ${isEdit ? "수정" : "추가"}`}
          subTitle={`작성 후 저장 버튼을 눌러주세요.`}
        />
        <Divider />
        {loading && <></>}
      </div>
      {!loading && (
        <>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form
              form={form}
              name="register"
              onFinish={onFinish}
              initialValues={{
                ...banner,
                startDateTime: (!banner?.startDateTime || JSON.stringify(banner?.startDateTime) == 'null') ? null : moment(banner?.startDateTime),
                endDateTime: (!banner?.endDateTime || JSON.stringify(banner?.endDateTime) == 'null') ? null : moment(banner?.endDateTime),
              }}
              scrollToFirstError
              style={{ width: "50%" }}
            >
              {/*<Form.Item name="isPopup" label="팝업 배너 여부" valuePropName="checked">*/}
              {/*  <Checkbox/>*/}
              {/*</Form.Item>*/}

              <Form.Item name="index" label="배너 순서">
                <Input placeholder="숫자를 입력해주세요." type="number" />
              </Form.Item>

              <Form.Item name="name" label="이름">
                <Input placeholder="이름을 입력해주세요. (상단 텍스트)" />
              </Form.Item>

              <Form.Item name="title" label="제목">
                <Input placeholder="제목을 입력해주세요. (중간 텍스트)" />
              </Form.Item>

              <Form.Item name="content" label="내용">
                <TextArea
                  placeholder={`내용을 입력해주세요.`}
                  rows={10}
                />
              </Form.Item>

              <Form.Item name="url" label="URL">
                <Input placeholder="URL을 입력해주세요." />
              </Form.Item>

              <Form.Item>
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    danger
                    htmlType="submit"
                    icon={<CloseOutlined />}
                    onClick={(e) => {
                      e.preventDefault();
                      onDelete(e)
                    }}
                    style={{ margin: "0 10px" }}
                  >
                    삭제
                  </Button>
                  <Button
                    htmlType="submit"
                    icon={<CloseOutlined />}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/setting/banner`);
                    }}
                    style={{ margin: "0 10px" }}
                  >
                    목록
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<CheckOutlined />}
                  >
                    저장
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </>
      )}
    </>
  );
}

export default BannerForm;
